"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCadGlobalSignalNamingRule = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
const OrcadNetNamingStrategy_1 = require("../OrcadNetNamingStrategy");
const orcadHighestLevelWins_1 = require("./orcadHighestLevelWins");
const OrcadDsnPortOccurrenceUtils_1 = require("../Generators/OrcadDsnPortOccurrenceUtils");
class OrCadGlobalSignalNamingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Naming;
    }
    apply(group, _hierarchy) {
        const candidates = [];
        let shallowestAliasDepth;
        let shallowestOffPageDepth;
        for (const [instance, nets] of group.getNets()) {
            const depth = instance.path.length;
            for (const net of nets) {
                for (const label of net.labels) {
                    if (label.labelType === 'global') {
                        candidates.push({
                            name: label.formattedLabel ?? label.originalLabel,
                            depth,
                        });
                    }
                    else if (label.labelType === 'alias') {
                        if (shallowestAliasDepth === undefined || depth < shallowestAliasDepth) {
                            shallowestAliasDepth = depth;
                        }
                    }
                    else if (label.labelType === 'off-page-connector') {
                        if (shallowestOffPageDepth === undefined || depth < shallowestOffPageDepth) {
                            shallowestOffPageDepth = depth;
                        }
                    }
                }
                for (const conn of net.connections) {
                    if (conn.connection.appliesNetName?.labelType === 'global') {
                        candidates.push({
                            name: conn.connection.appliesNetName.label.toUpperCase(),
                            depth,
                        });
                    }
                }
            }
        }
        if (candidates.length === 0) {
            return undefined;
        }
        candidates.sort((a, b) => {
            if (a.depth !== b.depth) {
                return a.depth - b.depth;
            }
            return sigma_engine_shared_1.Utils.naturalStringSort(a.name, b.name);
        });
        const shallowestGlobalDepth = candidates[0].depth;
        if (shallowestOffPageDepth !== undefined && shallowestOffPageDepth <= shallowestGlobalDepth) {
            return undefined;
        }
        if (this.crossesOccurrenceBoundary(group)) {
            const boundaryAlias = this.shallowestBoundaryAlias(group, shallowestGlobalDepth);
            if (boundaryAlias) {
                return boundaryAlias;
            }
            if (this.hasShallowerNamedSegment(group, shallowestGlobalDepth)) {
                return undefined;
            }
        }
        if (shallowestAliasDepth !== undefined && shallowestAliasDepth < shallowestGlobalDepth) {
            return undefined;
        }
        if ((0, orcadHighestLevelWins_1.deferToShallowerSystemId)(group, shallowestGlobalDepth)) {
            return undefined;
        }
        return candidates[0].name;
    }
    crossesOccurrenceBoundary(group) {
        const parentKeys = new Set();
        const childKeys = new Set();
        for (const label of group.getNetLabels()) {
            const occurrence = label.strategyMetadata?.['port-occurrence'];
            if (!occurrence) {
                continue;
            }
            if (label.labelType === 'hierarchical-sheet-entry') {
                parentKeys.add((0, OrcadDsnPortOccurrenceUtils_1.portOccurrenceIdentityKey)(occurrence));
            }
            else if (label.labelType === 'hierarchical-port') {
                childKeys.add((0, OrcadDsnPortOccurrenceUtils_1.portOccurrenceIdentityKey)(occurrence));
            }
        }
        return Array.from(parentKeys).some((key) => childKeys.has(key));
    }
    hasShallowerNamedSegment(group, globalDepth) {
        for (const [instance, nets] of group.getNets()) {
            if (instance.path.length >= globalDepth) {
                continue;
            }
            for (const net of nets) {
                if (net.name && !net.name.startsWith(OrcadNetNamingStrategy_1.OrCadNetNamingStrategy.AUTO_NET_PREFIX)) {
                    return true;
                }
            }
        }
        return false;
    }
    shallowestBoundaryAlias(group, globalDepth) {
        const candidates = [];
        for (const [instance, nets] of group.getNets()) {
            const depth = instance.path.length;
            if (depth >= globalDepth) {
                continue;
            }
            for (const net of nets) {
                for (const label of net.labels) {
                    if (label.labelType === 'alias') {
                        candidates.push({ name: label.formattedLabel ?? label.originalLabel, depth });
                    }
                }
            }
        }
        candidates.sort((left, right) => left.depth - right.depth || sigma_engine_shared_1.Utils.naturalStringSort(left.name, right.name));
        return candidates[0]?.name;
    }
}
exports.OrCadGlobalSignalNamingRule = OrCadGlobalSignalNamingRule;
//# sourceMappingURL=OrcadGlobalSignalNamingRule.js.map